/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetProjectsStatus200, GetProjectsStatus401 } from '../types/GetProjects'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getProjects } from '../clients/getProjects'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getProjectsQueryKey = () => [{ url: '/projects/' }] as const

type GetProjectsQueryKey = ReturnType<typeof getProjectsQueryKey>

export function getProjectsQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getProjectsQueryKey()
  return queryOptions<GetProjectsStatus200, ResponseErrorConfig<GetProjectsStatus401>, GetProjectsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getProjects({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /projects/}
 */
export function useGetProjects<TData = GetProjectsStatus200, TQueryData = GetProjectsStatus200, TQueryKey extends QueryKey = GetProjectsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetProjectsStatus200, ResponseErrorConfig<GetProjectsStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getProjectsQueryKey()

  const queryResult = useQuery({
   ...getProjectsQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetProjectsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
